export default __webpack_public_path__ + "static/media/slide-01.5af7f2ae.jpg";